import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Arrow } from 'ui/lexus/outlines';

import {
    InfoBlock,
    ButtonOutlined,
} from 'ui/lexus/components';

import styles from './styles';

const {
    CreditContainer,
    DropdownButton,
    MobileHeaderTitle,
    MobileHeaderArrow,
    DropdownMenu,
    UserMessageStyle,
} = styles;

const getCreditData = ({
    order, status, name,
// eslint-disable-next-line arrow-body-style
}) => {
    return [
        {
            title: 'Статус платежа',
            value: status,
        },
        {
            title: 'Cумма платежа',
            value: `${order?.amount} Р`,
        },
        {
            title: 'Юридическое лицо',
            value: `${name || 'Нет данных'}`,
        },
        {
            title: 'Плательщик',
            value: `${order?.lastName || ''} ${order?.firstName || ''} ${order?.middleName || ''}  `,
        },
        {
            title: 'Телефон',
            value: order?.phone,
        },
        {
            title: 'E-mail',
            value: order?.email,
        },
    ];
};

class CreditInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            dropdownIsOpen: true,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
    }

    componentDidMount() {
        const { gotStatusPage } = this.props;
        if (window.innerWidth < 900) {
            this.setState({ isMobile: true, dropdownIsOpen: gotStatusPage && gotStatusPage === true });
        }
    }

    render() {
        const {
            order,
            status,
            base,
            statusDescriprion,
            isLoadedStatus,
            dealerCenter,
            gotStatusPage,
            isLoadedFrame,
        } = this.props;
        const { dropdownIsOpen } = this.state;

        const { legalEntityResponseList } = dealerCenter.data;
        const creditInfoValue = Array.isArray(legalEntityResponseList) && legalEntityResponseList.length > 0 ? legalEntityResponseList[0] : {};
        const { name } = creditInfoValue;

        const merchantURL = '';

        return (
            <>
                <CreditContainer base={base} status={status}>
                    <DropdownButton onClick={this.handleClick} isOpen={dropdownIsOpen}>
                        <MobileHeaderTitle>Параметры заказа</MobileHeaderTitle>
                        <MobileHeaderArrow isOpen={dropdownIsOpen} src={Arrow} />
                    </DropdownButton>
                    <DropdownMenu base={base} className={dropdownIsOpen ? 'full-height' : ''} isLoadedFrame={isLoadedFrame}>
                        {getCreditData({
                            order, status, name,
                        }).map(field => (
                            <Fragment key={field.title}>
                                <InfoBlock
                                    title={field.title}
                                    value={field.value}
                                    status={field.title === 'Статус платежа' ? status : null}
                                    statusDescriprion={field.title === 'Статус платежа' ? statusDescriprion : null}
                                />
                            </Fragment>
                        ))}
                    </DropdownMenu>
                </CreditContainer>
                {(isLoadedStatus && !gotStatusPage) && (
                    <>
                        <UserMessageStyle>
                            Информация о статусе платежа отправлена на вышеуказанный e-mail
                        </UserMessageStyle>
                        <ButtonOutlined href={merchantURL} title="Вернуться на главную" status={status} />
                    </>
                )}
            </>
        );
    }
}

export default connect(
    state => ({
        dealerCenter: state.brand.dealerCenter,
        dealerCenterDetailed: state.brand.dealerCenterDetailed,
    }),
)(CreditInfo);
